/**
 * Twig.js
 *
 * @copyright 2011-2020 John Roepke and the Twig.js Contributors
 * @license   Available under the BSD 2-Clause License
 * @link      https://github.com/twigjs/twig.js
 */

module.exports = require('./twig.factory')();



// WEBPACK FOOTER //
// ./node_modules/twig/src/twig.js